import { InfoHoverPopover } from "../info-hover-popover";

export const GcxCashPopover = () => (
  <InfoHoverPopover>
    <h2>What is GCX Cash?</h2>
    <p>
      GCX Cash is a currency that can be redeemed on any GCX purchase. $1 of GCX
      Cash equals $1 of spending power on our website and mobile app.
    </p>
    <hr />
    <h2>How do I earn GCX Cash?</h2>
    <p>
      Buy a GCX Cash Gift Card for yourself, or send one as a gift to earn GCX
      Cash instantly. Select your desired denomination or enter the exact amount
      you’d like to spend to see your earning potential. You can also refer
      friends to earn GCX Cash.
    </p>
    <hr />
    <h2>How do I redeem GCX Cash?</h2>
    <p>
      GCX Cash is automatically applied for you at checkout. Your order total
      must be greater than the amount of GCX Cash applied.
    </p>

    <hr />
    <p className="note">
      <span>Please Note: </span> You cannot redeem promo codes on GCX Cash Gift
      Cards.
    </p>
  </InfoHoverPopover>
);
